<template>
        <div class="warp">
            <!-- 表单 -->
            <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>联系人：</div>
                    <div class="content"><el-input v-model="sendInfo.relationUser" maxlength="20"></el-input></div>
                </div>
                <div class="child">
                    <div class="name"><span>*</span>联系电话：</div>
                    <div class="content"><el-input v-model="sendInfo.contactNumber"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.contactNumber']">错误提示：{{errors['sendInfo.contactNumber']}}</div>

                <div class="child">
                    <div class="name"><span>*</span>E-mail：</div>
                    <div class="content"><el-input v-model="sendInfo.email"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.email']">错误提示：{{errors['sendInfo.email']}}</div>

                <div class="child">
                    <div class="name"><span>*</span>邮编：</div>
                    <div class="content"><el-input v-model="sendInfo.zipCode"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.zipCode']">错误提示：{{errors['sendInfo.zipCode']}}</div>

                <div class="child">
                    <div class="name"><span>*</span>地址：</div>
                    <el-select v-model="sendInfo.provinceId" @change="getCity(sendInfo.provinceId,true)" ref="province">
                        <el-option
                        v-for="(item,i) in provinceList"
                        :key="i"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="sendInfo.cityId" @change="getArea(sendInfo.cityId,true)" ref="city">
                        <el-option
                        v-for="(item,i) in cityList"
                        :key="i"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="sendInfo.areaId" @change="setMap" ref="area">
                    <el-option
                        v-for="(item,i) in areaList"
                        :key="i"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="errors">
                    <div class="error" v-if="errors['sendInfo.provinceId']">错误提示：{{errors['sendInfo.provinceId']}}</div>
                    <div class="error" v-if="errors['sendInfo.cityId']">错误提示：{{errors['sendInfo.cityId']}}</div>
                    <div class="error" v-if="errors['sendInfo.areaId']">错误提示：{{errors['sendInfo.areaId']}}</div>
                </div>
                <div class="child" style="align-items:flex-start">
                    <div class="name">企业介绍：</div>
                    <div class="content"><el-input type="textarea" :autosize="{minRows: 4}"  maxlength="300" show-word-limit  v-model="sendInfo.enterpriseIntro"></el-input></div>
                </div>
                <div class="child">
                    <div class="name hidden"><span>*</span>地址：</div>
                    <div class="content"><el-input v-model="sendInfo.address" @input="getMap"></el-input></div>
                </div>

                 <div class="child" v-show="sendInfo.areaId">
                    <div class="name hidden"><span>*</span>地址：</div>
					<div id="mapShow" class="map"></div>
                    <!-- <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @ready="handler">
                        <bm-marker :position="marker" :dragging="true" @dragend="drage"></bm-marker>
                    </baidu-map> -->
                </div>
                  
                <div class="child">
                    <div class="name"><span>*</span>微信公众号二维码：</div>
                    <div class="content"><upLoad :action="'backstage/annex/file'" 
					@input="inputValue" :accept="'image/png,image/jpg,image/jpeg'"
					  :size="20" :value="sendInfo.weiXinQrCodeUrl" is-need-limit
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="100"
            :autoCropHeight='100'/></div>
                </div>
                <div class="child">
                    <div class="name hidden"></div>
                    <div class="content">
                      <div class="hint">图片仅支持png、jpg，建议高宽比为1:1，尺寸不小于100*100px，大小不超过20M</div>
                    </div>
                </div>
                <div class="error" v-if="errors['sendInfo.weiXinQrCodeUrl']">错误提示：{{errors['sendInfo.weiXinQrCodeUrl']}}</div>
                <div class="child">
                    <div class="name"></div>
                    <div class="content">
                      <div class="singleBtn">
                        <el-button  type="primary"  size="small" v-if="authorities.indexOf('sys:permission:background:web:config:contact:us:button:save')!=-1" @click="submit">保存</el-button>
                        <!-- <el-button size="small" @click="$router.back(-1)">取消</el-button> -->
                    </div>
                    </div>
                </div>
                
            </div>
        </div>
</template>

<script>
import upLoad from '../../../components/upLoads';
export default {
    components:{
        upLoad
    },
	props: ['iData','tab'],
    data(){
        return{
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            sendInfo:{
                relationUser: void 0, // 联系人
                contactNumber:'',//联系电话
                email:'',//E-mail
                zipCode:'',//邮编
                provinceId:'',//省
                cityId:'',//市
                areaId:'',//区
                address:'',//详细地址
                weiXinQrCodeUrl:'',//二维码
                latitude:'',
                longitude:"",
                enterpriseIntro: void 0
            },
            provinceList:[],//省数组
            cityList:[],//市数组
            areaList:[],//区数组
            center:'',//地图中心店
            zoom:0,//地图缩放登记0-18
            marker:{},//标记
            Bmap:null,//地图容器
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
		'sendInfo.contactNumber':{
		    test:function(){
		        if(this.sendInfo.contactNumber){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'输入联系方式'
		},
        'sendInfo.email':'email',
        'sendInfo.zipCode':{
            test:function(){
                if(this.sendInfo.zipCode.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'输入邮编'
        },
        'sendInfo.provinceId':{
            test:function(){
                if(this.sendInfo.provinceId){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择省'
        },
        'sendInfo.cityId':{
            test:function(){
                if(this.sendInfo.cityId){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择市'
        },
        'sendInfo.areaId':{
            test:function(){
                if(this.sendInfo.areaId){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择区'
        },
        'sendInfo.weiXinQrCodeUrl':{
            test:function(){
                if(this.sendInfo.weiXinQrCodeUrl.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传logo'
        },
    },
    methods:{
		ready(lat,lng) {
			let map = new BMap.Map("mapShow");    
			let point = new BMap.Point(lng, lat);    
			map.centerAndZoom(point, 16);    
			map.enableScrollWheelZoom(true);
			map.enableDoubleClickZoom(true);
			let marker = new BMap.Marker(point);        // 创建标注    
			map.addOverlay(marker);                     // 将标注添加到地图中 
		},
        inputValue(value){
            this.sendInfo.weiXinQrCodeUrl = value
        },
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axioscBody.post('backstage/front/saveAboutUs',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        });
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //获取省
        getprovince:function(){
            this.$axiosz.get('backstage/sysAddress').then(res=>{
                if(res.code == 200){
                    this.provinceList = res.data
                }
            })
        },
        //获取市
        getCity:function(id,bl,cb){
            this.$axiosz.get('backstage/sysAddress/'+id).then(res=>{
                if(res.code == 200){
                    this.cityList = res.data
                    if(bl){
                        this.sendInfo.cityId = '';
                        this.sendInfo.areaId = '';
                    }
                    cb && cb()
                }
            })
        },
        //获取区
        getArea:function(id,bl,cb){
            this.$axiosz.get('backstage/sysAddress/'+id).then(res=>{
                if(res.code == 200){
                    this.areaList = res.data
                    if(bl){
                        this.sendInfo.areaId = '';
                    }
                    cb && cb()
                    this.setMap()
                }
            })
            // let list=[{label:'涪城区',value:'3'}]
            // this.areaList=list;
            // console.log(id)
        },
        //地图加载完成
        handler:function({BMap, maps}){
            this.BMap=BMap;
        },
        //选择了区绘制地图
        setMap:function(){
            setTimeout(() => {
                let address=this.$refs.province.selectedLabel+this.$refs.city.selectedLabel+this.$refs.area.selectedLabel;
                let myGeo = new this.BMap.Geocoder();
                myGeo.getPoint(address, (point)=>{
                    if (point) {
                        this.sendInfo.longitude = point.lng
                        this.sendInfo.latitude = point.lat
                        this.center=point;
                        this.marker=point;
                        this.zoom=16;
                    }      
                });
            },0)
        },
        //输入详细地址绘制地图
        getMap:function(){
            let myGeo = new this.BMap.Geocoder();
            setTimeout(() => {
                myGeo.getPoint(this.$refs.province.selectedLabel+this.$refs.city.selectedLabel+this.$refs.area.selectedLabel + this.sendInfo.address, (point)=>{
                    if (point) {
                        this.sendInfo.longitude = point.lng
                        this.sendInfo.latitude = point.lat
                        this.center=point;
                        this.marker=point;
						this.ready(point.lat,point.lng)
                        this.zoom=16;
                    }      
                });
            }, 0);
        },
        //拖拽标注点结束触发
        drage:function({type, target, pixel, point}){
            this.center=point;
            this.marker=point;
            this.zoom=16;
            let geoc = new this.BMap.Geocoder(); 
            geoc.getLocation(point, function(rs){});  
        }
    },
    mounted(){
		this.BMap=BMap;
        this.getprovince();
        let _this = this;
        this.$axiosc.get('backstage/front/aboutUs').then(res=>{
            if(res.code == 200){
                if(res.data.contactNumber){
                    this.sendInfo.contactNumber = res.data['contactNumber']
                    this.sendInfo.email = res.data['email']
                    this.sendInfo.zipCode = res.data['zipCode']
                    if(res.data['provinceId']){
                        let provinceId = function(){
                            _this.sendInfo.provinceId = res.data['provinceId'];
                        }
                        this.getCity(res.data['provinceId'],false,provinceId)
                    }
                    if(res.data['cityId']){
                        let cityId = function(){
                            _this.sendInfo.cityId = res.data['cityId']
                            _this.sendInfo.areaId = res.data['areaId']
                        }
                        this.getArea(res.data['cityId'],false,cityId)
                    }
                    this.sendInfo.enterpriseIntro = res.data['enterpriseIntro']
                    this.sendInfo.address = res.data['address']
                    this.sendInfo.weiXinQrCodeUrl = res.data['weiXinQrCodeUrl']
                    this.sendInfo.latitude = res.data['latitude']
                    this.sendInfo.longitude = res.data['longitude']
                    this.sendInfo.relationUser = res.data['relationUser']
					
					setTimeout(()=>{
						this.ready(res.data['latitude'],res.data['longitude'])
					},500)
                }
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .retrieve{
        padding: 0;
        margin-bottom: 20px;
        .child{
            margin: 0;
        }
    }
    .forms{
         max-width:70%;
         margin:0 auto;
         padding: 50px 0;
        .child{
            .name{
              width:150px;
              text-align: right;
            }
            /deep/ .el-select{
                width: 100px;
                margin-right: 5px;
            }
            .hidden{
                visibility: hidden;
            }
            .map{
                width:500px;
                height: 300px;
            }
        }
        .errors{
            width: 450px;
        }
    }
}
</style>